import apiOffice from "../../axios/apiOffice";
import setTokenUser from "../../office/tokens/refreshTokenUser";
import setTokenRelations from "../../office/tokens/refreshTokenRelations";
import store from "@/store";

function getIdCategories() {
  return store?.state?.categoriesRelations || null;
}

async function handleServiceError(error, retryFn) {
  if (!error.response) {
    console.error("Backend inaccesible:", error.message);
    throw new Error("NETWORK_ERROR");
  }

  const { status, data } = error.response;

  if (status === 500) {
    if (data?.message === "Token de usuario expirado") {
      const ok = await setTokenUser();
      if (ok) return retryFn();
    }

    if (data?.message === "Token de representante expirado") {
      const ok = await setTokenRelations();
      if (ok) return retryFn();
    }
  }

  throw error;
}

export async function getAllCategories() {
  const response = await apiOffice.get("/oficina/categories/categories");

  const categories = response.data?.Categories;
  if (!categories) throw new Error("Formato inválido");

  const idCategories = getIdCategories();

  const all = [
    ...(categories.Procedures || []),
    ...(categories.taxArray || []),
    ...(categories.licencesArray || []),
    ...(categories.generalRequestsCategory || []),
  ];

  all.forEach((item) => {
    if (idCategories) {
      item.ruta = idCategories.includes(item.id);
    } else {
      item.ruta = true;
    }
  });

  return {
    formales: categories.Procedures || [],
    impuestos: categories.taxArray || [],
    transito: categories.licencesArray || [],
    general: categories.generalRequestsCategory || [],
  };
}

export async function getCategoriesInPerson() {
  try {
    const idCategories = getIdCategories();

    const response = await apiOffice.get(
      "/oficina/categories/in-person-categories",
    );

    let categoriesApi = response.data.categories;
    let proceduresApi = response.data.procedures;
    let subCategoriesApi = [];

    // marcar rutas
    if (idCategories) {
      categoriesApi.forEach((item) => {
        item.ruta = idCategories.includes(item.id);
      });
    } else {
      categoriesApi.forEach((item) => {
        item.ruta = true;
      });
    }

    // subcategorías únicas
    if (proceduresApi) {
      proceduresApi.forEach((item) => {
        if (item.subCategory) {
          const exists = subCategoriesApi.some(
            (sub) => sub.id === item.subCategory.id,
          );

          if (!exists) {
            subCategoriesApi.push(item.subCategory);
          }
        }
      });
    }

    return { categoriesApi, proceduresApi, subCategoriesApi };
  } catch (error) {
    console.error("Error al obtener categorías:", error);

    if (error?.response?.status === 500) {
      if (error?.response?.data?.message === "Token de usuario expirado") {
        const ok = await setTokenUser();
        if (ok) return getCategoriesInPerson();
      }

      if (
        error?.response?.data?.message === "Token de representante expirado"
      ) {
        const ok = await setTokenRelations();
        if (ok) return getCategoriesInPerson();
      }
    }

    throw error;
  }
}
export async function getSubCateries(id) {
  try {
    const response = await apiOffice.get(`/subcategories/sub-categories/${id}`);

    const procedures = response.data.subCategories["Procedures"] || null;
    const subCategories =
      procedures === null ? response.data.subCategories : null;

    return { subCategories, procedures };
  } catch (error) {
    return handleServiceError(error, () => getSubCateries(id));
  }
}

export async function getProceduresSubCategory(id) {
  try {
    const response = await apiOffice.get(`/subcategories/procedures/${id}`);
    return response.data.procedures;
  } catch (error) {
    return handleServiceError(error, () => getProceduresSubCategory(id));
  }
}
